// --- Relay endpoint (your AWS Lambda, no token in browser) ---
const RELAY_URL = "https://xhsd67wnc2bflahdtgabhn6o5u0siazb.lambda-url.us-east-2.on.aws/";

// Static dev toggle (still supported)
const STATIC_ENABLED =
  /[?&]debug=1\b/.test(location.search) ||
  localStorage.getItem("debug") === "1" ||
  /^(localhost|127\.0\.0\.1)$/.test(location.hostname);

// Runtime flag (we’ll turn this ON only for Qualifi visitors)
let RUNTIME_ENABLED = false;

// Cost control
const BS_SAMPLE = 1.0;   // percentage of logged sessions (1.0 = 100%)
const MAX_LOGS = 25;     // per page load
let SENT_COUNT = 0;

// 🔹 enable at runtime (called before Qualifi flow)
export function bsEnable() {
  RUNTIME_ENABLED = true;
}

// 🔹 internal sanitizer
function redact(obj) {
  try {
    const c = JSON.parse(JSON.stringify(obj ?? {}));
    const scrub = (o) => {
      if (!o || typeof o !== "object") return;
      for (const k of Object.keys(o)) {
        const key = k.toLowerCase();
        if (/(email|phone|ssn|dob|address|authorization|token|password)/.test(key))
          o[k] = "***redacted***";
        else if (typeof o[k] === "object") scrub(o[k]);
        else if (typeof o[k] === "string" && o[k].length > 600)
          o[k] = o[k].slice(0, 600) + "…";
      }
    };
    scrub(c);
    return c;
  } catch {
    return { note: "redaction_failed" };
  }
}

// force fetch: set BEACON_ENABLED = false for now
const BEACON_ENABLED = false;

export async function bsLog(event, data = {}, level = "info") {
  const enabled = STATIC_ENABLED || RUNTIME_ENABLED;
  console.info("[bsLog] called", { enabled });
  if (!enabled) { console.info("[bsLog] SKIP: disabled"); return; }
  if (Math.random() > BS_SAMPLE) { console.info("[bsLog] SKIP: sampling"); return; }
  if (SENT_COUNT >= MAX_LOGS) { console.info("[bsLog] SKIP: MAX_LOGS reached"); return; }
  SENT_COUNT++;
  console.info("[bsLog] SENDING:", event);

  const body = {
    dt: new Date().toISOString(),
    level,
    event,
    service: "fe-app",
    href: location.href,
    data: redact(data),
  };
  const json = JSON.stringify(body);

  // 1) (disabled) sendBeacon path
  if (BEACON_ENABLED && navigator.sendBeacon) {
    try {
      const ok = navigator.sendBeacon(
        RELAY_URL,
        new Blob([json], { type: "text/plain;charset=UTF-8" }) // use safelisted type
      );
      console.info("[bsLog] sendBeacon() return:", ok);
      if (ok) return;
    } catch (e) {
      console.warn("[bsLog] sendBeacon() failed:", e);
    }
  }

  // 2) fetch fallback – choose ONE of these modes:
  // If your Lambda Function URL CORS is configured, keep 'cors'
  // If you're unsure about CORS, use 'no-cors' (server still receives; you won't get readable response)
  const MODE = "cors"; // or "no-cors"

  try {
    const res = await fetch(RELAY_URL, {
      method: "POST",
      // IMPORTANT: with no-cors, stick to safelisted headers & text/plain body
      headers: { "Content-Type": "text/plain;charset=UTF-8" },
      body: json,
      keepalive: true,
      mode: MODE,
    });
    console.info("[bsLog] fetch sent; status:", res?.status);
  } catch (e) {
    console.warn("[bsLog] fetch failed", e);
  }
}
  

// 🔹 optional helper for building sanitized payloads
export function buildFormPayload(obj) {
  const out = {};
  for (const [k, v] of Object.entries(obj || {})) {
    const key = String(k);
    if (v === undefined || v === null) out[key] = "";
    else if (typeof v === "boolean") out[key] = v ? "1" : "0";
    else if (typeof v === "number") out[key] = String(v);
    else out[key] = v;
  }
  return out;
}
